import styles from './styles.less';
import React from 'react';
import ReactDOM from 'react-dom';
import { isObject, isString } from 'lodash';

class Image extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const img = ReactDOM.findDOMNode(this);
        if (img.complete) {
            this.props.onLoad();
        }
    }

    render() {
        let mobileImageUrl, desktopImageUrl;
        const { data, title, maxWidth, onLoad } = this.props;

        if (isString(data)) {
            desktopImageUrl = data;
        } else {
            mobileImageUrl = (isObject(data.mobile)) ? data.mobile.url : data.mobile;
            desktopImageUrl = (isObject(data.desktop)) ? data.desktop.url : data.desktop;
        }

        let style = {
            maxWidth: (maxWidth) ? maxWidth + '%' : '100%'
        };

        if (!mobileImageUrl)
            return (
                <img
                    alt={ title }
                    className={ styles.image }
                    onLoad={ onLoad }
                    src={ desktopImageUrl }
                    style={ style }
                />
            );

        else return (
            <picture>
                <source
                    media="(max-width: 800px)"
                    srcSet={ mobileImageUrl }
                />
                <img
                    alt={ title }
                    className={ styles.image }
                    src={ desktopImageUrl }
                    style={ style }
                />
            </picture>
        );
    }
}


export default Image;



// WEBPACK FOOTER //
// ./src/client/components/image/index.js